module.exports = __webpack_public_path__ + "media/ruby_room.b79ab277.wav";